/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UsernameWithPopoverContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"UserPopoverContainer_settings">;
    readonly " $refType": "UsernameWithPopoverContainer_settings";
};
export type UsernameWithPopoverContainer_settings$data = UsernameWithPopoverContainer_settings;
export type UsernameWithPopoverContainer_settings$key = {
    readonly " $data"?: UsernameWithPopoverContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UsernameWithPopoverContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UsernameWithPopoverContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserPopoverContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '916b2c82c38767eef7e01479ffe73b4d';
export default node;
